module.exports = __webpack_public_path__ + "static/media/triple.0bb9b48b.svg";